module.exports = __webpack_public_path__ + "9177d81c2380af100f14540d7a04ca97.svg";